import {
  FieldValuePickerDefaultOption,
  FieldValuePickerGroupedOption,
  FieldValuePickerOption,
} from 'common/filter/components/Condition/ConditionValue/FieldValuePicker/interfaces'
import {
  reasonTypeLabels,
  reasonTypeSequence,
} from 'common/oneTimeNotify/constants/notifyReasonConstants'

export const prepareGroupedOption = (
  options: FieldValuePickerDefaultOption[],
): FieldValuePickerGroupedOption[] => {
  if (!options.length) return []
  // prepare object
  const preparedOptions: { [key: string]: FieldValuePickerGroupedOption } = {}
  options.forEach((option) => {
    preparedOptions[option.entity_type]
      ? preparedOptions[option.entity_type].options.push(getPrepareOption(option))
      : (preparedOptions[option.entity_type] = {
          label: reasonTypeLabels[option.entity_type],
          options: [getPrepareOption(option)],
        })
  })
  // sort by reasonType
  const result: FieldValuePickerGroupedOption[] = []
  reasonTypeSequence.forEach((el) => preparedOptions[el] && result.push(preparedOptions[el]))

  return result
}

const getPrepareOption = (option: FieldValuePickerDefaultOption): FieldValuePickerOption => {
  return {
    label: option.label,
    type: option.type,
    value: option.value,
    segment_type: option.segment_id,
    count: option.count,
  }
}

export const isNeedGroupOption = (options: FieldValuePickerDefaultOption[]): boolean => {
  return options.every((option) => !!option.entity_type)
}
